import { Stack, Typography } from '@rossum/ui/material';

type RenderDatapointLabelProps = {
  datapointLabel: string;
  schemaId: string;
};
export const RenderDatapointLabel = ({
  datapointLabel,
  schemaId,
}: RenderDatapointLabelProps) => {
  return (
    <Stack sx={{ height: 1, justifyContent: 'center' }}>
      <Typography variant="body2">{datapointLabel}</Typography>
      <Typography variant="caption" color="text.secondary">
        {schemaId}
      </Typography>
    </Stack>
  );
};
